import React, { useState } from 'react';
import moment from 'moment';

import { useApi } from '../../../utils/hooks';
import ErrorComponent from '../../../components/Error';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock , faCaretDown } from '@fortawesome/free-solid-svg-icons';


import Modal from '../../Modal';

function ArsenalSchedule() {
    // Change state Modal
    const [open, setOpen] = useState(false);

    // Call the API to fetch the data
    const { data, loading, error } = useApi(`arsenal-schedule/`);

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    // Display a message if there is no data
    if (data.results.length === 0) return <p className="title-3">Arsenal</p>;

    // Find the current schedule based on the current day
    const currentSchedule = data.results.find(
        (data) => data.day === moment().format('dddd')
    );

    return (
        <>
            <div id="title-hour">
                <p className="title-3">
                    Arsenal <br />
                </p>
                <div id="hours" onClick={() => setOpen(true)}>
                    <p className="hour">
                        <FontAwesomeIcon
                            icon={faClock}
                            className="icon-hour"
                            size="sm"
                        />
                        {currentSchedule?.closed
                            ? 'Fermé'
                            : `${currentSchedule?.opening_time} - ${currentSchedule?.closing_time}`}
                    </p>
                    <div>
                        <FontAwesomeIcon
                            icon={faCaretDown}
                            size="xl"
                            className="schedule-btn"
                        />
                    </div>
                </div>
            </div>

            <Modal open={open} onClose={() => setOpen(false)}>
                <p className="title">Horaires</p>
                {data.results?.map((schedule) => (
                    <div key={schedule.id} className="schedule">
                        <span className="schedule-day">{schedule.day}</span>
                        <span className="schedule-hours">
                            {schedule.closed
                                ? 'Fermé'
                                : `${schedule.opening_time} - ${schedule.closing_time}`}
                        </span>
                    </div>
                ))}
                <div className="restaurant-address">
                    Rue Bruno, 11 - 5000 Namur
                </div>
            </Modal>
        </>
    );
}

export default ArsenalSchedule;
